import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService } from './data.service';
import { ListItemDTO, ListItemWriteDTO } from '../interfaces/listItem';

@Injectable({
  providedIn: 'root'
})
export class ListItemService {

  constructor(private dataService: DataService) { }

  saveListItem(listItemId: number, listItem: ListItemWriteDTO): Observable<ListItemDTO> {
    if (listItemId && listItemId > 0) {
      return this.dataService.updateListItem(listItemId, listItem);
    } else {
      return this.dataService.createListItem(listItem);
    }
  }

  deleteListItem(listItem: ListItemDTO): Observable<any> {
    if (listItem && listItem.id > 0) {
      return this.dataService.deleteListItem(listItem.id);
    } else return of(null);
  }

  getListItems(listId: number): Observable<any> {
    return this.dataService.getListItems(listId);
  }

  getListItem(listItemId: number): Observable<any> {
    return this.dataService.getListItem(listItemId);
  }

  updateListItemPosition(listItemId: number, position: number): Observable<any> {
    if (listItemId && listItemId > 0) {
      return this.dataService.updateListItemPosition(listItemId, position);
    } else return of (null);
  }
}
